import { useStore } from '../store'
import { patchMe } from '../api/auth'
import i18n from '../i18n'

export function useLanguage() {
  const { language, setLanguage } = useStore()

  const changeLanguage = async (lang: string) => {
    try {
      await patchMe({ preferred_language: lang })
    } catch {
      // best-effort — UI wisselt altijd, ook als opslaan mislukt
    }
    setLanguage(lang)
    i18n.changeLanguage(lang)
  }

  return { language, changeLanguage }
}
